import dayjs from "dayjs";
import { matchPath } from "react-router-dom";
import { formatRelativeTime } from "../../utils";

export const POST_SLUG_PATTERNS = [
  "/blogs/public/:postName",
  "/video/:postName",
  "/blog/:postName",
];

export const getPostRouteParams = (pathname) => {
  if (!pathname || typeof pathname !== "string") {
    return {};
  }

  for (const pattern of POST_SLUG_PATTERNS) {
    const match = matchPath(pattern, pathname);
    if (match?.params) {
      return match.params;
    }
  }

  return {};
};

export const getBackNavigation = (pathname) => {
  if (matchPath("/blogs/public/:postName", pathname)) {
    return { to: "/blogs/public", label: "Back to Public Blog", feedLabel: "Public Blog" };
  }

  return {
    to: "/blogs/premium/",
    label: "Back to Member Content",
    feedLabel: "Feed",
  };
};

export const getPostTypeLabel = (post) =>
  post?.contentTypeId === 2 ? "Video" : "Blog";

export const isPremiumLocked = (post, user) => {
  if (!post) return true;

  const missingBody =
    post.contentTypeId === 1 && post.content === undefined;
  const missingVideo =
    post.contentTypeId === 2 && post.embeddedVideo === undefined;

  return Boolean(missingBody || missingVideo);
};

export const isFreePublicPost = (post) => post?.contentAvailabilityId === 1;

export const shouldShowComments = (post, user) =>
  Boolean(user && post?.content);

/** Lovable-style date: absolute + relative only when recent (avoids duplicate timestamps). */
export const formatPostDetailDate = (publishedAt) => {
  if (!publishedAt) return "";

  const normalized = publishedAt.replace(" ", "T");
  const formatted = dayjs(normalized).format("MMMM D, YYYY");
  const relative = formatRelativeTime(publishedAt);

  if (relative && /ago|Just now/.test(relative)) {
    return `${formatted} · ${relative}`;
  }

  return formatted;
};
